import AccessTokens from 'ui/screens/Settings/AccessTokens'
import AiChat from 'ui/screens/AIChat'
import Clients from 'ui/screens/EditPatient/Clients'
import CookiePreferences from 'ui/screens/Settings/CookiePreferences'
import { Daily } from 'ui/clinicianScreens/Patient/Daily'
import Devices from 'ui/screens/EditPatient/Devices'
import EditDevice from 'ui/screens/EditPatient/Devices/EditDevice'
import EditPatient from 'ui/screens/EditPatient'
import { Log } from 'ui/clinicianScreens/Patient/Log'
import { Overview } from 'ui/clinicianScreens/Patient/Overview'
import Organizations from 'ui/screens/Organizations'
import AdminLayout from 'ui/screens/Admin'
import OutreachDashboard from 'ui/screens/OutreachManagement/tabs/OutreachDashboard/OutreachDashboard'
import TagsTab from 'ui/screens/OutreachManagement/tabs/TagsTab/TagsTab'
import TemplatesTab from 'ui/screens/OutreachManagement/tabs/TemplatesTab/TemplatesTab'
import CampaignsTab from 'ui/screens/OutreachManagement/tabs/CampaignsTab/CampaignsTab'
import HighlightCardsTab from 'ui/screens/OutreachManagement/tabs/HighlightCardsTab/HighlightCardsTab'
import HighlightCardDetails from 'ui/screens/OutreachManagement/HighlightCardDetails'
import CardContentEditor from 'ui/screens/OutreachManagement/CardContentEditor'
import PushNotificationsTab from 'ui/screens/OutreachManagement/tabs/PushNotificationsTab/PushNotificationsTab'
import TemplateEditor from 'ui/screens/OutreachManagement/TemplateEditor'
import CampaignDashboard from 'ui/screens/OutreachManagement/CampaignDashboard'
import CampaignDetails from 'ui/screens/OutreachManagement/CampaignDetails'
import TagDetails from 'ui/screens/OutreachManagement/TagDetails'
import CompliancePage from 'ui/screens/ComplianceManagement/CompliancePage'
import Patient from 'ui/screens/Patient'
import PatientDetails from 'ui/screens/EditPatient/PatientDetails/PatientDetails'
import PatientList from 'ui/screens/Patients/PatientList'
import Profile from 'ui/screens/Settings/Profile'
import Settings from 'ui/screens/Settings'
import { SignIn } from 'ui/screens/SignIn'
import { Summary } from 'ui/clinicianScreens/Patient/Summary'
import TaskNotifications from 'ui/screens/Patients/TaskNotifications'
import Users from 'ui/screens/Users'
import { Report } from 'ui/clinicianScreens/Patient/Report'
import ReportPatientPDFTest from 'ui/clinicianScreens/Patient/Report/ReportPatientPDFTest'
import { WeeklyView } from 'ui/clinicianScreens/Patient/WeeklyView'
import { ROUTE_METADATA } from 'app/AppRoutes/RouteMetadata'

export const ROUTES = {
  accessTokens: {
    path: ROUTE_METADATA.accessTokens.path,
    element: <AccessTokens />,
    title: ROUTE_METADATA.accessTokens.title,
  },
  aiChat: {
    path: ROUTE_METADATA.aiChat.path,
    element: <AiChat />,
    title: ROUTE_METADATA.aiChat.title,
  },
  clients: {
    path: ROUTE_METADATA.clients.path,
    element: <Clients />,
  },
  cookiePreferences: {
    path: ROUTE_METADATA.cookiePreferences.path,
    element: <CookiePreferences />,
    title: ROUTE_METADATA.cookiePreferences.title,
  },
  daily: {
    path: ROUTE_METADATA.daily.path,
    element: <Daily />,
    title: ROUTE_METADATA.daily.title,
  },
  details: {
    path: ROUTE_METADATA.details.path,
    element: <PatientDetails />,
  },
  deviceId: {
    path: ROUTE_METADATA.deviceId.path,
    element: <EditDevice />,
  },
  devices: {
    path: ROUTE_METADATA.devices.path,
    element: <Devices />,
  },
  editPatient: {
    path: ROUTE_METADATA.editPatient.path,
    element: EditPatient,
    title: ROUTE_METADATA.editPatient.title,
  },
  log: {
    path: ROUTE_METADATA.log.path,
    element: <Log />,
    title: ROUTE_METADATA.log.title,
  },
  overview: {
    path: ROUTE_METADATA.overview.path,
    element: <Overview />,
    title: ROUTE_METADATA.overview.title,
  },
  organizations: {
    path: ROUTE_METADATA.organizations.path,
    element: <Organizations />,
    title: ROUTE_METADATA.organizations.title,
  },
  admin: {
    path: ROUTE_METADATA.admin.path,
    element: <AdminLayout />,
    title: ROUTE_METADATA.admin.title,
  },
  adminOutreachDashboard: {
    path: 'outreach/dashboard',
    element: <OutreachDashboard />,
    title: ROUTE_METADATA.adminOutreachDashboard.title,
  },
  adminOutreachTags: {
    path: 'outreach/tags',
    element: <TagsTab />,
    title: ROUTE_METADATA.adminOutreachTags.title,
  },
  adminOutreachTemplates: {
    path: 'outreach/templates',
    element: <TemplatesTab />,
    title: ROUTE_METADATA.adminOutreachTemplates.title,
  },
  adminOutreachCampaigns: {
    path: 'outreach/campaigns',
    element: <CampaignsTab />,
    title: ROUTE_METADATA.adminOutreachCampaigns.title,
  },
  adminOutreachHighlightCards: {
    path: 'outreach/highlight-cards',
    element: <HighlightCardsTab />,
    title: ROUTE_METADATA.adminOutreachHighlightCards.title,
  },
  adminOutreachHighlightCardDetails: {
    path: 'outreach/highlight-cards/:cardId',
    element: <HighlightCardDetails />,
    title: ROUTE_METADATA.adminOutreachHighlightCardDetails.title,
  },
  adminOutreachCardContentEditor: {
    path: 'outreach/highlight-cards/:cardId/content',
    element: <CardContentEditor />,
    title: ROUTE_METADATA.adminOutreachCardContentEditor.title,
  },
  adminOutreachPushNotifications: {
    path: 'outreach/push-notifications',
    element: <PushNotificationsTab />,
    title: ROUTE_METADATA.adminOutreachPushNotifications.title,
  },
  adminOutreachTemplateNew: {
    path: 'outreach/templates/new',
    element: <TemplateEditor />,
    title: ROUTE_METADATA.adminOutreachTemplateNew.title,
  },
  adminOutreachTemplateEdit: {
    path: 'outreach/templates/:templateId',
    element: <TemplateEditor />,
    title: ROUTE_METADATA.adminOutreachTemplateEdit.title,
  },
  adminOutreachCampaignDashboard: {
    path: 'outreach/campaigns/:campaignId',
    element: <CampaignDashboard />,
    title: ROUTE_METADATA.adminOutreachCampaignDashboard.title,
  },
  adminOutreachCampaignEdit: {
    path: 'outreach/campaigns/:campaignId/edit',
    element: <CampaignDetails />,
    title: ROUTE_METADATA.adminOutreachCampaignEdit.title,
  },
  adminOutreachTagNew: {
    path: 'outreach/tags/new',
    element: <TagDetails />,
    title: ROUTE_METADATA.adminOutreachTagNew.title,
  },
  adminOutreachTagEdit: {
    path: 'outreach/tags/:tagId',
    element: <TagDetails />,
    title: ROUTE_METADATA.adminOutreachTagEdit.title,
  },
  adminCompliance: {
    path: 'compliance',
    element: <CompliancePage />,
    title: ROUTE_METADATA.adminCompliance.title,
  },
  patientId: {
    path: ROUTE_METADATA.patientId.path,
    element: <Patient />,
  },
  patients: {
    path: ROUTE_METADATA.patients.path,
    element: <PatientList />,
    title: ROUTE_METADATA.patients.title,
  },
  profile: {
    path: ROUTE_METADATA.profile.path,
    element: <Profile />,
    title: ROUTE_METADATA.profile.title,
  },
  reportClinician: {
    path: ROUTE_METADATA.reportClinician.path,
    element: <Report isClinicianReport />,
    title: ROUTE_METADATA.reportClinician.title,
  },
  reportPatient: {
    path: ROUTE_METADATA.reportPatient.path,
    element: <Report />,
    title: ROUTE_METADATA.reportPatient.title,
  },
  reportPatientPDFTest: {
    path: ROUTE_METADATA.reportPatientPDFTest.path,
    element: <ReportPatientPDFTest />,
    title: ROUTE_METADATA.reportPatientPDFTest.title,
  },
  settings: {
    path: ROUTE_METADATA.settings.path,
    element: <Settings />,
    title: ROUTE_METADATA.settings.title,
  },
  signin: {
    path: ROUTE_METADATA.signin.path,
    element: <SignIn />,
  },
  summary: {
    path: ROUTE_METADATA.summary.path,
    element: <Summary />,
    title: ROUTE_METADATA.summary.title,
  },
  summaryComparison: {
    path: ROUTE_METADATA.summaryComparison.path,
    element: <Summary />,
    title: ROUTE_METADATA.summaryComparison.title,
  },
  taskNotifications: {
    path: ROUTE_METADATA.taskNotifications.path,
    element: <TaskNotifications />,
  },
  users: {
    path: ROUTE_METADATA.users.path,
    element: <Users />,
    title: ROUTE_METADATA.users.title,
  },
  weeklyView: {
    path: ROUTE_METADATA.weeklyView.path,
    element: <WeeklyView />,
    title: ROUTE_METADATA.weeklyView.title,
  },
}
